import { render } from "./blockType.vue?vue&type=template&id=2b16dbaf&scoped=true"
import script from "./blockType.vue?vue&type=script&lang=js"
export * from "./blockType.vue?vue&type=script&lang=js"

import "./blockType.vue?vue&type=style&index=0&id=2b16dbaf&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b16dbaf"]])

export default __exports__